// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"rainbow"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 17C2 11.4772 6.47715 7 12 7C17.5228 7 22 11.4772 22 17M5 17C5 13.134 8.13401 10 12 10C15.866 10 19 13.134 19 17M8 17C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RainbowIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'rainbow',
    ref,
    icon: element,
  },
));

RainbowIcon.displayName = 'RainbowIcon';

export default RainbowIcon;
